import React, { useEffect } from 'react';

const SprinkleBackground = () => {
  useEffect(() => {
    const colors = ['#ec4899', '#14b8a6', '#fbbf24', '#f97316'];
    const container = document.getElementById('sprinkle-container');

    // Create sprinkles
    for (let i = 0; i < 20; i++) {
      const sprinkle = document.createElement('div');
      sprinkle.className = 'sprinkle sprinkle-float';
      sprinkle.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      sprinkle.style.left = Math.random() * 100 + '%';
      sprinkle.style.top = Math.random() * 100 + '%';
      sprinkle.style.animationDelay = Math.random() * 5 + 's';
      sprinkle.style.animationDuration = (10 + Math.random() * 10) + 's';
      container.appendChild(sprinkle);
    }

    return () => {
      container.innerHTML = '';
    };
  }, []);

  return (
    <div
      id="sprinkle-container"
      className="fixed inset-0 pointer-events-none z-0 overflow-hidden"
      style={{ opacity: 0.15 }}
    />
  );
};

export default SprinkleBackground;